export default {
  API_HOST: 'http://localhost:1234',
  FEEDBACK_URL: 'https://app.smartsheet.com/b/form/97489111f33948a29692ae9bae12e121',
};



// WEBPACK FOOTER //
// ./src/config/dev.ts